// extracted by mini-css-extract-plugin
export default {"createAlphaGrid":"CreateAlphaGrid_createAlphaGrid__y-plo","message":"CreateAlphaGrid_message__iKDQz"};